import script from "./Inventories.vue?vue&type=script&setup=true&lang=js"
export * from "./Inventories.vue?vue&type=script&setup=true&lang=js"

import "./Inventories.vue?vue&type=style&index=0&id=5c74444d&lang=css"

const __exports__ = script;

export default __exports__